(() => {
  const selector = '[data-aa-material-menu]';
  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.matches(selector) || !menu.open) return;
    document.querySelectorAll(selector).forEach((other) => {
      if (other !== menu && other.dataset.aaMaterialMenu === menu.dataset.aaMaterialMenu) other.open = false;
    });
  }, true);
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || event.target.closest('.aa-material-item')) return;
    document.querySelectorAll(selector).forEach((menu) => { menu.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const active = document.activeElement;
    document.querySelectorAll(selector).forEach((menu) => {
      if (!menu.open) return;
      const restoreFocus = menu.contains(active);
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary')?.focus();
    });
  });
})();
